import { render, staticRenderFns } from "./CustomerHistory.template.vue?vue&type=template&id=60f5c3dc&scoped=true&"
var script = {}
import style0 from "./CustomerHistory.template.vue?vue&type=style&index=0&id=60f5c3dc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f5c3dc",
  null
  
)

export default component.exports